export default class {
    constructor (lodash, FormFactory, AutomatedPlanningGroupResource) {
        this.lodash = lodash;
        this.FormFactory = FormFactory;
        this.AutomatedPlanningGroupResource = AutomatedPlanningGroupResource;
    }

    setPlanningGroup (planningGroup) {
        this.planningGroup = planningGroup;
    }

    setTargets (targets) {
        this.courseTargets = targets;
    }

    init () {
        this.selectedTargetIds = [];
        this.createForm();
        this.availableTargets = this.courseTargets.filter(
            (courseTarget) => !this.planningGroup.planningGroupTargetsWithValue.find((target) => target.courseTargetId === courseTarget.id)
        );
    }

    /**
     * Resets form targets to db state
     */
    resetFormTargets () {
        this.form.model.targets = angular.copy(this.planningGroup.planningGroupTargetsWithValue);
    }

    createForm () {
        this.form = this.FormFactory.create(this.planningGroup, model => model.$update({ id: model.id }));

        this.resetFormTargets();
    }

    addTarget (courseTargetId) {
        this.form.model.targets.push({
            id: null,
            courseTargetId
        });
    }

    toggleAll () {
        this.selectedTargetIds = this.checked ? this.availableTargets.map((target) => target.id) : [];
    }

    hasTarget (key) {
        return this.lodash.includes(this.selectedTargetIds, key);
    }

    toggleTarget (key) {
        if (this.hasTarget(key)) {
            this.lodash.pull(this.selectedTargetIds, key);
            this.checked = false;
        }
        else {
            this.selectedTargetIds.push(key);
        }
    }

    beforeSave () {
        this.resetFormTargets();
        this.selectedTargetIds.forEach((targetId) => this.addTarget(targetId));
    }

    save () {
        this.beforeSave();
        const targets = this.form.model.targets.map(target => ({
            id: target.id || null,
            courseTargetId: target.courseTargetId
        }));

        return this.AutomatedPlanningGroupResource.setTargets(
            { id: this.planningGroup.id },
            { targets }
        ).$promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/planningGroupTarget/index.js